import { FormWidgetError } from '~/common/form/formError'
import { Type } from '~/common/form/type'
import { Validations } from '~/common/form/validation'

export interface SignupType extends Type {
  organization_code: string
  organization_name: string
  user_name: string
  email: string
  password: string
}

export const initialData: SignupType = {
  organization_code: '',
  organization_name: '',
  user_name: '',
  email: '',
  password: '',
}

export const signupValidation: Validations = {
  organization_code: [FormWidgetError.IS_EMPTY, FormWidgetError.BELOW_CODE_MIN_LENGTH, FormWidgetError.OVER_SHORT_STRING_MAX, FormWidgetError.NOT_CODE, FormWidgetError.IS_PROHIBITED_FOR_CODE],
  organization_name: [FormWidgetError.IS_EMPTY, FormWidgetError.OVER_SPACE_NAME_STRING_MAX],
  user_name: [FormWidgetError.IS_EMPTY, FormWidgetError.OVER_NORMAL_STRING_MAX],
  email: [FormWidgetError.IS_EMPTY, FormWidgetError.OVER_NORMAL_STRING_MAX, FormWidgetError.NOT_EMAIL],
  password: [FormWidgetError.IS_EMPTY, FormWidgetError.OVER_NORMAL_STRING_MAX, FormWidgetError.BELOW_PASSWORD_MIN_LENGTH,
    FormWidgetError.NOT_ALPHA_NUMERIC_SYMBOL, FormWidgetError.NOT_INCLUDE_ALPHA_NUMERIC]
}